import { createReducer, on } from '@ngrx/store';

import { ChangeRequest, InitialChangeRequestState } from '../models';
import {
  addressChangeAgentEmailSuccess,
  PolicyChangeRequestNotificationSuccessAction,
  PolicyChangeRequestSuccessEmailNotificationAction,
  vinChangeAgentEmailSuccess
} from './policy-change.actions';

export const initialState: ChangeRequest = new InitialChangeRequestState();

export const reducer = createReducer(
  initialState,
  on(
    addressChangeAgentEmailSuccess,
    vinChangeAgentEmailSuccess,
    PolicyChangeRequestSuccessEmailNotificationAction,
    PolicyChangeRequestNotificationSuccessAction,
    (state, action) => action.payload
  )
);
